<div [ngClass]="(openStatus$ | async) ? 'open' : ''"
     class="side-bar-nav side-menu">
  <div class="nav-bar">
    <app-nav-button-bar></app-nav-button-bar>
  </div>
</div>
<div (click)="toggleSideBarState()" [ngClass]="(openStatus$ | async) ? 'active' : ''" class="dark-overlay">
</div>
